interface IProps {
  show: boolean
  text?: string
}

export const EndOfResults: React.FC<IProps> = ({ show, text }) => (
  <div className='w-full'>
    {show && (
      <div className='text-text-muted uppercase flex items-center justify-center gap-[8%] text-[0.75rem] mt-4 mb-6 px-6 opacity-55'>
        <div className='h-[1px] grow bg-text-muted' />
        {text || 'End of results'}
        <div className='h-[1px] grow bg-text-muted' />
      </div>
    )}
  </div>
)
